import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k2/question-5.png'
import imgQuestion8 from '../../../../ui/images/questions/ela/grade-k2/question-8.png'
import imgQuestion10 from '../../../../ui/images/questions/ela/grade-k2/question-10.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k2_1',
    title: 'Which sentence is used to ask for permission?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k2_1_a',
        text: 'I am going to the bathroom.',
      },
      {
        name: 'grade_k2_1_b',
        text: 'May I go to the bathroom, please?',
        correct: true,
      },
      {
        name: 'grade_k2_1_c',
        text: 'You can go to the bathroom.',
      },
    ],
  },
  {
    name: 'grade_k2_2',
    title: 'Which word begins with the same sound as "chair"?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k2_2_a',
        text: 'ship',
      },
      {
        name: 'grade_k2_2_b',
        text: 'cheese',
        correct: true,
      },
      {
        name: 'grade_k2_2_c',
        text: 'bear',
      },
    ],
  },
  {
    name: 'grade_k2_3',
    title: 'Which word rhymes with "bear"?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k2_3_a',
        text: 'Fear',
      },
      {
        name: 'grade_k2_3_b',
        text: 'Far',
      },
      {
        name: 'grade_k2_3_c',
        text: 'Pear',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_4',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"In winter, some trees lose their leaves. They do this to save water. The tree stays quiet and waits for the warm spring sun to grow new leaves."',
    sentence: 'Why do trees drop their leaves in winter?',
    answers: [
      {
        name: 'grade_k2_4_a',
        text: 'Because the leaves are too heavy',
      },
      {
        name: 'grade_k2_4_b',
        text: 'To keep and save their water',
        correct: true,
      },
      {
        name: 'grade_k2_4_c',
        text: 'Because the strong wind blows them away',
      },
    ],
  },
  {
    name: 'grade_k2_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Sofia looked at the clock and realized she was almost late for school."',
    sentence: 'What did Sofia realize?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k2_5_a',
        text: 'She forgot her homework.',
      },
      {
        name: 'grade_k2_5_b',
        text: 'She was already at school.',
      },
      {
        name: 'grade_k2_5_c',
        text: 'She will not be on time for school.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Although the Sun looks like a small coin in the sky, it is actually a million times larger than Earth. It appears tiny only because of the vast space between us."',
    sentence: 'What is the main reason the Sun looks small?',
    answers: [
      {
        name: 'grade_k2_6_a',
        text: 'Because it is the same size as a coin.',
      },
      {
        name: 'grade_k2_6_b',
        text: 'Because it is actually smaller than the planets.',
      },
      {
        name: 'grade_k2_6_c',
        text: 'Because of the great distance from our planet.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_7',
    title: 'Which sentence is written correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k2_7_a',
        text: 'the dog barked at the cat.',
      },
      {
        name: 'grade_k2_7_b',
        text: 'The Dog Barked at the Cat',
      },
      {
        name: 'grade_k2_7_c',
        text: 'The dog barked at the cat.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_8',
    title: 'Choose the best sentence to describe this picture:',
    topic: AssessmentTopics.Writing,
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k2_8_a',
        text: 'The girl is running with a red balloon.',
      },
      {
        name: 'grade_k2_8_b',
        text: 'The girl is sitting on the grass with her kite.',
      },
      {
        name: 'grade_k2_8_c',
        text: 'The girl is flying a red kite in the park.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_9',
    title: 'Which word best completes this sentence?',
    topic: AssessmentTopics.Writing,
    detail: 'It was so ______ outside that Sarah had to hold onto her hat so it wouldn\'t fly away.',
    answers: [
      {
        name: 'grade_k2_9_a',
        text: 'sunny',
      },
      {
        name: 'grade_k2_9_b',
        text: 'windy',
        correct: true,
      },
      {
        name: 'grade_k2_9_c',
        text: 'quiet',
      },
    ],
  },
  {
    name: 'grade_k2_10',
    title: 'Which word is an adjective in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The tall giraffe ate leaves from the tree.',
    image: imgQuestion10,
    answers: [
      {
        name: 'grade_k2_10_a',
        text: 'giraffe',
      },
      {
        name: 'grade_k2_10_b',
        text: 'tall',
        correct: true,
      },
      {
        name: 'grade_k2_10_c',
        text: 'leaves',
      },
    ],
  },
  {
    name: 'grade_k2_11',
    title: 'Which word correctly completes the sentence?',
    topic: AssessmentTopics.Language,
    detail: 'Lily was sad because she ______ her favorite book at school.',
    answers: [
      {
        name: 'grade_k2_11_a',
        text: 'loses',
      },
      {
        name: 'grade_k2_11_b',
        text: 'losed',
      },
      {
        name: 'grade_k2_11_c',
        text: 'lost',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_12',
    title: 'Which word is a verb in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The puppy chased the ball across the yard.',
    answers: [
      {
        name: 'grade_k2_12_a',
        text: 'puppy',
      },
      {
        name: 'grade_k2_12_b',
        text: 'chased',
        correct: true,
      },
      {
        name: 'grade_k2_12_c',
        text: 'ball',
      },
    ],
  },
]
